import { Layout } from "components";
import {
  AlertPanel,
  ALink,
  BackButton2,
  CommonButton,
  CommonButton2,
  InputText,
  NextButton2, Radio, RadioList,
  SeparatorLine
} from "components/CommonUI";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {XAPPOINTMENT, XAPPOINTMENTDETAIL, XCHOOSEIDTYPE, XLANDING} from "../constants/route";
import {isValidCpfAccountNumber, isValidEmail, isValidOTP, isValidPassport, safeVal} from "../utils/common";
import { getExistingAppointmentX, getOtpEmail, verifyOTPEmail } from "../services/api-service";
import { Modal } from "react-bootstrap";
import { useOtpTime } from "../hooks";
import { clear, clearVerification, verifyNext } from "../redux/xAppointment";
import { useSelector, useDispatch, batch } from "react-redux";
import ReCAPTCHA from "react-google-recaptcha";

const unexpectedError = <p>Unexpected error has occurred. Please try again.</p>;
const dataMismatchErrorPassport = (
  <>
    <h4>Invalid Passport number / Email address</h4>
    <p>
      <b>Please try agian.</b>
    </p>
  </>
);

const dataMismatchErrorCPFAccountNumber = (
  <>
    <h4>Invalid CPF Account number / Email address</h4>
    <p>
      <b>Please try agian.</b>
    </p>
  </>
);

// https://www.cpf.gov.sg/member/tools-and-services/forms-e-applications/cash-top-ups-and-cpf-transfers-for-retirement
/**
 * States;
 * initial
 * Data fill
 * Press Get OTP Code
 *  Data fill invalid
 *   Error
 *  Data fill valid
 *   Lock data fill
 *   Show Edit details button
 *   Show otp form
 *    Otp timeout
 *      Resend otp link show
 *   Hide Get OTP Code button
 *   Show Verify OTP button
 * Press Edit details button
 *  Unlock data fill
 *  Hide Edit details button
 *  Hide otp form
 *  Hide Verify OTP button
 *  Show Get OTP Code button.
 * Press Verify OTP button
 *  Invalid OTP
 *   Error
 *  Valid OTP
 *    Go Next
 */
export default function XLandingPage() {
  const [hasDataFilled, setHasDataFilled] = useState(false);
  // const [passport, setPassport] = useState("123456");
  const passport = useRef();
  const [passportError, setPassportError] = useState(null);
  const email = useRef();
  // const [email, setEmail] = useState("a@b.com");
  const [emailError, setEmailError] = useState(null);
  const [error, setError] = useState(null);
  // const [otp, setOtp] = useState();
  const otp = useRef();
  const [otpError, setOtpError] = useState(null);
  // const [otpExpired, setOtpExpired] = useState(false);
  const { start: startOtpTime, stop: stopOtpTime, time: otpTime } = useOtpTime();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isLoading: loading, } = useSelector((state) => state.loading);
  const { haveCpfAccountNumber } = useSelector((state) => state.xAppointment);

  const [captchaResponseToken, setCaptchaResponseToken] = useState(null);

  /*const getOtpEmailApi = useApiCall(getOtpEmail, {
      passport: passport.current?.value,
      email: email.current?.value
    }, setError);*/

  // onload
  useEffect(() => {
    dispatch(clearVerification());

    // mock
    /*passport.current.value = "A123456";
    email.current.value = "aungthiha@gmail.com";*/
    setTimeout(() => passport.current.focus(), 500);
  }, []);

  const clkBack = () => {
    navigate(XCHOOSEIDTYPE);
  };

  const validateOTP = () => {
    if (!isValidOTP(safeVal(otp))) {
      setOtpError("Please provide a valid OTP.");
      otp.current.focus();
      return false;
    } else {
      setOtpError(null);
      return true;
    }
  };

  const validateEmailPassport = () => {
    let isOk = true;

    if(!haveCpfAccountNumber && !isValidPassport(safeVal(passport))) {
        setPassportError("This field is mandatory.");
        isOk = false;
    } else if (haveCpfAccountNumber && !isValidCpfAccountNumber(safeVal(passport))) {
        setPassportError("Enter a valid CPF Account Number (e.g. SA987654C).");
        isOk = false;
    } else {
        setPassportError(null);
    }

    if (!isValidEmail(safeVal(email))) {
      setEmailError("Enter a valid email address (e.g. yourname@email.com).");
      isOk = false;
    } else {
      setEmailError(null);
    }

    return isOk;
  };

  const clkGetOtp = async () => {

    if (otp && otp.current) {
      otp.current.value = "";
    }

    // Prevent double click for A link "resend"
    if (loading) {
      return;
    }

    if (!validateEmailPassport()) {
      return;
    }

    /*getOtpEmailApi(()=>{
      // All is well
      setHasDataFilled(true);
      // setOtpExpired(false);
      startOtpTime(45);
    });*/

    const status = await getOtpEmail({
      passport: safeVal(passport).toUpperCase(),
      email: safeVal(email),
      captchaResponseToken
    });
    if (status !== "SUCCESS") {
      setError(unexpectedError);
      return;
    }

    // All is well
    setHasDataFilled(true);
    startOtpTime(window.emailOtpExpSecs);
  };

  const clkVerifyOtp = async () => {
    if (!validateOTP()) {
      return;
    }

    const result = await verifyOTPEmail({
      passport: safeVal(passport).toUpperCase(),
      email: safeVal(email),
      otp: safeVal(otp)
    });
    if (result.status !== "SUCCESS") {
      setError(unexpectedError);
      return;
    }

    if (!result.data?.validation) {
      setOtpError("The OTP is incorrect. Please try again.");
      return;
    }
    setOtpError(null);

    const { otpToken, expAt } = result.data;

    // All is well
    dispatch(
      verifyNext({
        otpToken,
        otpTokenExpAt: expAt,
        email: safeVal(email),
        passport: safeVal(passport).toUpperCase()
      })
    );

    // Check if there is existing appointment
    const { status, data: existingAppt } = await getExistingAppointmentX({
      passport: safeVal(passport).toUpperCase(),
      otpToken
    });
    if (status === "NO_AUTH") {
      setError(haveCpfAccountNumber ? dataMismatchErrorCPFAccountNumber : dataMismatchErrorPassport);
      return;
    } else if (status !== "SUCCESS") {
      setError(unexpectedError);
      return;
    }

    if (existingAppt && existingAppt.id) {
      navigate(XAPPOINTMENTDETAIL, { state: { isJustCreatedOrUpdated: false } });
      return;
    }

    // setTimeout(()=>{
    navigate(XAPPOINTMENT);
    // });
  };

  const clkEditDetails = () => {
    setHasDataFilled(false);
    // setOtpExpired(false);
    stopOtpTime();
  };

  const onReCaptchaChange = (v) => {
    console.log("onReCaptchaChange", v);
    setCaptchaResponseToken(v);
  }

  const clkGetNewOTP = () => {
    setCaptchaResponseToken(null);
    clkEditDetails();
  }

  /*  console.count("render");
    console.log("loading", loading)*/

  return (
    <Layout
      loginRequired={false}
      subHeader={"How can we help?"}
      noSubHeaderMainText={true}
      // mainText={"Test"}
    >
      <div style={{ minHeight: 700 }}>
        <div className="form-box--plain mt-3">
          <div className={"px-1 px-sm-3 py-3 py-md-5"}>
            <h4 className={"mb-4 text-center"}>Enter your details</h4>

            <div className="row justify-content-center pb-3">
              <div className="col-12 col-md-8 col-lg-6" style={{ border: "0px solid red" }}>
                <div>
                  <div>Does your CPF Account number start with SA, SB, SF, SD or TC?</div>
                  <span style={{ color: "gray", fontStyle: "italic" }}>
                    e.g., SA987654C or TC987654C
                  </span>
                </div>
              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-12 col-md-4 col-lg-3" style={{ border: "0px solid red" }}>
                <Radio
                  id="haveCpfAccountNumber"
                  label={"Yes"}
                  value={true}
                  checked={haveCpfAccountNumber === true}
                  disabled={true}
                  needCol={false}
                />
              </div>
              <div className="col-12 col-md-4 col-lg-3" style={{ border: "0px solid red" }}>
                <Radio
                  id="haveCpfAccountNumber"
                  label={"No"}
                  value={false}
                  checked={haveCpfAccountNumber === false}
                  disabled={true}
                  needCol={false}
                />
              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-12 col-md-8 col-lg-6" style={{ border: "0px solid red" }}>
                <div className="mt-20">
                  <InputText
                    label={ haveCpfAccountNumber ? "CPF Account number" : "Passport number" }
                    placeholder={ haveCpfAccountNumber ? "e.g. SA987654C" : "" }
                    // value={"A123456"}
                    // onChange={(e) => setPassport(e.target.value.trim())}
                    ref={passport}
                    isInvalid={passportError !== null}
                    errorMessage={passportError}
                    disabled={hasDataFilled}
                    style={{ textTransform: "uppercase" }}
                  />
                </div>
                <div className="mt-20 mb-3">
                  <InputText
                    label="Email address"
                    placeholder="e.g. example@example.com"
                    // value={email}
                    // onChange={(e) => setEmail(e.target.value.trim())}
                    ref={email}
                    isInvalid={emailError !== null}
                    errorMessage={emailError}
                    disabled={hasDataFilled}
                    footNote={
                      "This email address will be used for one-time password (OTP) validation."
                    }
                  />
                </div>

                {!hasDataFilled && (
                  <div className="mt-20 mb-3" style={{display:"flex", justifyContent:"center"}}>
                    <ReCAPTCHA
                      sitekey={window.reCaptchaSiteKey}
                      onChange={onReCaptchaChange}
                    />
                  </div>
                )}

                {hasDataFilled && (
                  <>
                    <div className={"w-100 justify-center"}>
                      <CommonButton2
                        whiteOrFill={"white"}
                        text={"Edit details"}
                        onClick={clkEditDetails}
                      />
                    </div>

                    <SeparatorLine style={{ marginLeft: 0, marginRight: 0 }} />

                    <p>
                      A One-Time Password (OTP) has been sent to{" "}
                      <span style={{ fontWeight: 600 }}>{safeVal(email)}</span>.
                    </p>
                    <div>
                      <InputText
                        label="Enter OTP"
                        // placeholder="OTP"
                        ref={otp}
                        // value={otp}
                        // onChange={(e) => setOtp(e.target.value.trim())}
                        isInvalid={otpError !== null}
                        errorMessage={otpError}
                      />
                    </div>
                    {otpTime !== null && (
                      <span className="cmp-button__text">You can get a new OTP in {otpTime}.</span>
                    )}
                    {otpTime === null && (
                      <span className="cmp-button__text">
                        OTP has expired. &nbsp;
                        <a
                          className="cmp-button cmp-button--link"
                          onClick={clkGetNewOTP}
                          rel="noreferrer">
                          <u>Get new OTP.</u>
                        </a>
                        .
                      </span>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>

          <div className="form-footer">
            {/*<div className={"flex--space-between"}>*/}
            <div
              className={
                "w-100 d-flex flex-column-reverse flex-md-row justify-content-between px-md-3 py-2 align-items-start "
              }>
              <div className={"mobile-w-100"}>
                <BackButton2 onClick={clkBack} />
              </div>
              <div className={"mb-3 mb-md-0 mobile-w-100"}>
                <NextButton2
                  disabled={loading || captchaResponseToken === null || (hasDataFilled && otpTime === null)}
                  onClick={hasDataFilled ? clkVerifyOtp : clkGetOtp}
                  text={hasDataFilled ? "Next" : "Get OTP"}
                />
              </div>
            </div>
          </div>
          <Modal show={error !== null}>
            <Modal.Header className="bg-button-color" closeButton={false} />
            <Modal.Body className="p-3">
              <div className={"text-center"}>
                <i
                  className={`icon-dls-warning-solid icon-big`}
                  style={{ color: "#a46200", fontSize: 80 }}
                  aria-hidden="true"></i>
                {error}
              </div>
            </Modal.Body>
            <Modal.Footer className="justify-content-center">
              <CommonButton text={"OK"} leftOrRight={"right"} onClick={() => setError(null)} />
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </Layout>
  );
}
